export default "__VITE_ASSET__DsSXh_Jc__"